module.exports = __webpack_public_path__ + "static/img/banner_we_01.aba94a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/home/banner_we_01.png
// module id = tbmp
// module chunks = 10